import { SerializedSmartLink } from 'fym-common/src/db/serializersTypes';

export interface PostMessagableWindow {
  postMessage: (message: string, domain?: string) => void; // domain needed for browsers
}

export type SendMessageToPreviewFunc = (
  domain: string
) => (childWindow: PostMessagableWindow, message: SMLAppMessage) => void;
export enum SMLPreviewMessages {
  up = 'SMLPreview.up',
  down = 'SMLPreview.down',
  edit = 'SMLPreview.edit',
  /** The pointer is on a block of the preview, or left it (null). Editor redesign 2026-10-20. */
  hover = 'SMLPreview.hover',
}
export interface SMLPreviewMessageData {
  type: SMLPreviewMessages;
  /** Null only for `SMLPreview.hover` when the pointer left the blocks. */
  widgetUUID: string | null;
}
export enum SMLAppMessages {
  smartLinkUpdate = 'SMLApp.smartLinkUpdate',
  /** The open block of the editor: the preview draws a violet outline and "Editing · <type>". */
  selectBlock = 'SMLApp.selectBlock',
  /** The block under the pointer in the editor panel: the preview draws the hover outline. */
  hoverBlock = 'SMLApp.hoverBlock',
}
interface SMLAppMessageData<Type extends SMLAppMessages, Data> {
  type: Type;
  data: Data;
}

export type SMLAppMessageSmartLinkUpdate = SMLAppMessageData<
  SMLAppMessages.smartLinkUpdate,
  { smartLink: SerializedSmartLink }
>;

export type SMLAppMessageSelectBlock = SMLAppMessageData<SMLAppMessages.selectBlock, { widgetUUID: string | null }>;

export type SMLAppMessageHoverBlock = SMLAppMessageData<SMLAppMessages.hoverBlock, { widgetUUID: string | null }>;

export type SMLAppMessage = SMLAppMessageSmartLinkUpdate | SMLAppMessageSelectBlock | SMLAppMessageHoverBlock;
